import axios from "axios";
import { store } from "../store";
import { refreshToken } from "../store/authReducer";
import { notify } from "../utils/notificationUtils";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_STAGE_ENV}`,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use((config) => {
    const auth = store.getState().auth;
    if (auth.token) {
        config.headers.Authorization = `Bearer ${auth.token}`;
        config.headers['x-tenant'] = auth.tenant
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error.config || {};
        const status = error.response?.status;
        const message = error.response?.data?.message || error.message;
        const showNotify = config.showNotify !== false;

        if (status === 403 && !config._retry) {
            try {
                const newConfig = { ...config, _retry: true };
                await store.dispatch(refreshToken()).unwrap();
                return api(newConfig);
            } catch {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                window.location.href = "/login";
                return Promise.reject(error);
            }
        }

        if (showNotify && status >= 400 && status < 600) {
            notify(message?.error || message, "error");
        }

        return Promise.reject(error);
    }
);

export default api;
